export const usernameGenerator = (name) => {
  const username = name.replace(/\s/g, ".").substring(0, 30).toLowerCase();
  return username;
};

export const isMobile = (mobile) => {
  const mobilePattern = /^[0-9]{10}$/;

  if (mobile.length !== 10) {
    return "Mobile Digits not equal 10";
  }
  if (mobile[0] !== "0" || mobile[1] !== "7") {
    return "Wrong phone number";
  }
  if (!mobilePattern.test(mobile)) {
    return "All Digits should be number";
  }
  return true;
};

export const isAgeCorrect = (age) => {
  const isAge = /^(([1-8][0-9]?|9[0-8]?)\.\d+|[1-9][0-9]?)$/;

  return isAge.test(age);
};
